import React from 'react'


function Breaker(props) {
  return (
    <div style={{minHeight:"100px"}}>
      
    </div>
  )
}

export default Breaker